const SubmissionIndex = () => import('@/pages/lab/submission/SubmissionIndex');
const SubmissionDetail = () => import('@/pages/lab/submission/SubmissionDetail');
const SubmissionReportDetail = () => import('@/pages/lab/submission/SubmissionReportDetail');
const SubmissionSingle = () => import('@/pages/lab/submission/SubmissionSingle');
const SubmissionReceiveLabelIndex = () => import('@/pages/lab/submission/SubmissionReceiveLabelIndex');
const SubmissionAuditTrail = () => import('@/pages/lab/submission/SubmissionAuditTrail');
const SubmissionAuditTrailHistory = () => import('@/pages/lab/submission/SubmissionAuditTrailHistory');
const SubmissionEdit = () => import('@/pages/lab/submission/SubmissionEdit');
const ProjectWizard = () => import("@/external/project-wizard/pages/ProjectWizard")
const SampleAdd = () => import("@/pages/lab/sample/SampleAdd");
const SubmissionApplyTestPackage = () => import("@/pages/lab/submission/SubmissionApplyTestPackage");
const TestPackageApplyTestPackage = () => import("@/pages/lab/testpackage/TestPackageApplyTestPackage");

export class SubmissionRoutes {
  constructor() {
    this.route_root = "submissions";
    this.type_single = "Submission";
    this.type_plural = "Submissions";
    
    this.routes = [
      {
        path: this.route_root,
        component: {
          render(c) {
            return c("router-view");
          },
        },
        redirect: this.route_root,
        name: this.type_plural,
        meta: { requiresAuth: true },
        children: [
          {
            path: "",
            component: SubmissionIndex,
            meta: { requiresAuth: true },
          },
          {
            path: "add",
            component: { render (c) { return c('router-view') } },
            children: [
              {
                path: "",
                redirect: "/projects/add",
              },
              {
                path: ":project_id/:step?",
                name: `Add ${this.type_single}`,
                props: (route) => ({
                  step: route.params.step,
                  path: `/${this.type_plural}/add/${route.params.project_id}/`,
                  project_id: route.params.project_id,
                }),
                component: ProjectWizard,
                meta: { requiresAuth: true },
              }
            ]
          },
          {
            path: "apply-test-package",
            name: "Apply A Test Package",
            component: TestPackageApplyTestPackage,
            meta: { requiresAuth: true }
          },
          {
            path: ":submission_id",
            component: SubmissionSingle,
            children: [
              {
                path: "",
                component: SubmissionDetail,
                name: this.type_single,
                meta: { requiresAuth: true },
              },
              {
                path: "edit",
                name: `Update ${this.type_single}`,
                component: SubmissionEdit,
                meta: { requiresAuth: true },
              },
              {
                path: "labels",
                name: `${this.type_single} Labels`,
                component: SubmissionReceiveLabelIndex,
                meta: { requiresAuth: true },
              },
              {
                path: "report",
                name: `${this.type_single} Report`,
                component: SubmissionReportDetail,
                meta: { requiresAuth: true },
              },
              {
                path: "audit-trail",
                name: `${this.type_single} Audit Trail`,
                component: SubmissionAuditTrail,
                meta: { requiresAuth: true },
              },
              {
                path: "audit-trail-history",
                name: `${this.type_single} Audit Trail History`,
                component: SubmissionAuditTrailHistory,
                meta: { requiresAuth: true },
              },
              {
                path: "add-sample",
                name: "Add Sample",
                component: SampleAdd,
                meta: { requiresAuth: true }
              },
              {
                path: "apply-test-package",
                name: "Apply Test Package",
                component: SubmissionApplyTestPackage,
                meta: { requiresAuth: true }
              }
            ],
          },
        ],
      },
    ];

    this.public_routes = [];
  }

  static fetchRoutes() {
    const this_obj = new this();

    return this_obj.routes;
  }

  static fetchPublicRoutes() {
    const this_obj = new this();

    return this_obj.public_routes;
  }
}

